import { gql } from 'apollo-boost';

export const SEARCH_TOTAL_QUERY = gql`
query search($types: [ES_SearchOptionsTypesEnum!], $query: String, $page: Int, $limit: Int, $sort: ES_SearchOptionsSortEnum, $order: ES_SearchOptionsOrderEnum, $personId: UUID, $localeCode: ES_SearchOptionsLocaleCodeEnum, $categoryId: UUID) {
    search(searchOptions: {types: $types, query: $query, page: $page, limit: $limit, sort: $sort, order: $order, personId: $personId, localeCode: $localeCode, categoryId: $categoryId}) {
      totalCount
    }
  }
`;